import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs/internal/Observable';
import { MappingFieldsRequestParamDto } from '../../dto';

@Injectable({
    providedIn: 'root',
})
export class DynamicsApiService {
    private readonly url = 'service/contactcloud/dynamics';

    constructor(private readonly baseApiService: BaseApiService) { }

    authenticate(code: string): Observable<any> {
        return this.baseApiService.post('dynamics/authenticate', {}, { params: { code } });
    }

    refreshToken(): Observable<any> {
        return this.baseApiService.post('dynamics/refreshToken');
    }

    logout(): any {
        return this.baseApiService.get(`dynamics/logout`);
    }

    getSettings(): Observable<any> {
        return this.baseApiService.get(`${this.url}/settings`);
    }

    getMappingFields(params: MappingFieldsRequestParamDto = {}): Observable<any> {
        const requestParams = params.isAutomation ? { is_automation: true } : {};
        return this.baseApiService.get(`${this.url}/fields`, { params: requestParams });
    }

    updateSettings(settings): Observable<any> {
        return this.baseApiService.put(`${this.url}/settings`, settings);
    }

    loadLeadOwners() {
        return this.baseApiService.get(`${this.url}/leadowners`);
    }

    loadCampaigns() {
        return this.baseApiService.get(`${this.url}/campaigns`);
    }

    validateDuplicates(exportType: string, ids: number[], icpintel_job_uuid: string) {
        return this.baseApiService.post(`${this.url}/duplicate`, {
            exportType,
            icpintel_job_uuid,
            ids
        });
    }

    export(exportType: string, leadOwner: string, campaigns: number[], duplicateResolution: string, ids: number[], icpintel_job_uuid: string) {
        return this.baseApiService.post(`${this.url}/export`, {
            exportType,
            leadOwner,
            campaigns,
            duplicateResolution: duplicateResolution === 'skip' ? '' : duplicateResolution,
            icpintel_job_uuid,
            ids
        });
    }

    validateCompaniesDuplicates(requestBody) {
        return this.baseApiService.post(`${this.url}/companies/duplicate`, requestBody);
    }

    exportCompany(requestBody) {
        return this.baseApiService.post(`${this.url}/companies/export`, requestBody);
    }

    validateMapping(): Observable<any> {
        return this.baseApiService.get(`${this.url}/validateMapping`);
    }
}
